import { SwiperManager } from '../components/SwiperManager';

/**
 * BrandDetailPage — ブランド詳細ページ固有の初期化
 * body[data-page="brand-detail"] のときのみ実行される
 *
 * Swipers:
 *   .js-brand-usecase-swiper … USE CASE（SP:1.2枚 / TB:2.3枚 / PC:3枚グリッド・フラクション・カスタムナビ）
 */
export class BrandDetailPage {
  private readonly swiperManager: SwiperManager;

  constructor() {
    this.swiperManager = new SwiperManager();
  }

  init(): void {
    this.initUseCaseSwiper();
  }

  /**
   * USE CASE スライダー
   * SP/TB: Swiper スライダー / PC: 3枚全表示（column-slider と同仕様）
   */
  private initUseCaseSwiper(): void {
    this.swiperManager.init('.js-brand-usecase-swiper', SwiperManager.presets.brandUsecase);
  }

  destroy(): void {
    this.swiperManager.destroyAll();
  }
}
